import { StyleSheet } from 'react-native';
import { Colors } from '../themes/colors';
import { Spacing } from '.';
import { tokens } from '../components/crop-circle/tokens';

export const formStyles = StyleSheet.create({
  formItem: {
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.smallPadding.paddingVertical,
    backgroundColor: Colors.white,
    marginBottom: 4,
  },
  formItemTitle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 8,
  },
  formItemTitleCropCircle: {
    ...tokens.typography.body.small,
    fontWeight: '600',
    marginBottom: 4,
  },
});
